import React, { useState } from "react";
import { getDailySheet } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import Example from "./calling.js";
import SideBar from "../../sidebar/sideBar";

const LogSheet = () => {
  const { access_token } = useSelector(authSelector);
  const [dateEntered, setDateEntered] = useState("");
  const setDate = (e) => {
    setDateEntered(e.target.value);
  };
  console.log(dateEntered);
  const [itemsQueue, setItemsQueue] = useState([]);

  const editHandler = async (e) => {
    if (!dateEntered) return message.error("Please type date !");
    let data = {
      enteredOn: dateEntered,
    };
    const results = await getDailySheet(data, access_token);
    console.log(results.data.length, "ressaaaaa");
    if(results.data.length === 0){
      message.error('No Record Found in this date');
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            enteredOn: curr.enteredOn,
            itemCode: curr.itemCode,
            itemName: curr.itemName,
            saleRate: Number(curr.saleRate),
            purchaseRate: Number(curr.purchaseRate),
            quantity: Number(curr.quantity),
            partyName: curr.partyName,
            partyId: Number(curr.partyId),
            shift: Number(curr.shift),
            nozelNumber: curr.nozelNumber,
            meterStarting: Number(curr.meterStarting),
            meterEnding: Number(curr.meterEnding),
            tankNumber: curr.tankNumber,
            mmOpening: Number(curr.mmOpening),
            quantityOpening: Number(curr.quantityOpening),
            mmClosing: Number(curr.mmClosing),
            quantityClosing: Number(curr.quantityClosing),
            generalLedgerCode: Number(curr.generalLedgerCode),
            generalLedgerDescription: curr.generalLedgerDescription,
            description: curr.description,
            purchaseVoucherNo: curr.purchaseVoucherNo,
            voucherNumber: curr.voucherNumber,
            cheqNumber: curr.cheqNumber,
            debit: curr.debit,
            credit: curr.credit,
            siteId: curr.siteId,
            printOrder: curr.printOrder,
            itemDescription: curr.itemDescription,
            meterCheck: curr.meterCheck,
            balanceQty: Number(curr.balanceQty),
            nozelOrder: Number(curr.nozelOrder),
          },
        ];
      }, []);
      setItemsQueue(payload);
      //   setItemsQueue(results.data);
      console.log(itemsQueue, "FUn");
      //   if (results.data.length > 0) {
      //     navigate("/stockBalence");
      //   }
    } else {
      message.error(results.message);
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  console.log(itemsQueue, "payy");
  return (
    <>
      {itemsQueue.length > 0 ? (
        <>
          <div style={{ backgroundColor: "" }}>
            {itemsQueue.length > 0 && <Example item={itemsQueue} />}
          </div>
          <div className="pb-3 flex justify-center">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
            onClick={clearState}
            >
            Exit
          </button>
            </div>
        </>
      ) : (
        <>
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <div className="flex justify-center mt-32">
                <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className=" text-white">Log Sheet</h1>
                  </div>
                  <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                    <div>
                      <label className="text-white" for="fname">
                        Date:
                      </label>
                      <input
                        type="date"
                        className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                        onChange={setDate}
                      />
                    </div>
                    <div>
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                        onClick={editHandler}
                      >
                        View
                      </button>
                      <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                        clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LogSheet